(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-design-system"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-countdown')) {
    customElements.define('ap-countdown', class extends HTMLElement {
      connectedCallback() {
        window.clearInterval(this.timer);
        this.cells = { hours: this.querySelector('[data-hours]'), minutes: this.querySelector('[data-minutes]'), seconds: this.querySelector('[data-seconds]') };
        this.storageKey = this.dataset.storageKey || 'lushie-hour-offer-v1';
        this.duration = Math.max(1, Number.parseInt(this.dataset.durationSeconds || '3600', 10)) * 1000;
        this.expiredDuration = Math.max(0, Number.parseInt(this.dataset.expiredSeconds || '1200', 10)) * 1000;
        let storedEnd = null;
        try { storedEnd = window.localStorage.getItem(this.storageKey); } catch (error) {}
        if (storedEnd === null) {
          this.end = Date.now() + this.duration;
          try { window.localStorage.setItem(this.storageKey, String(this.end)); } catch (error) {}
        } else {
          this.end = Number(storedEnd);
        }
        if (!Number.isFinite(this.end)) {
          this.end = Date.now() + this.duration;
          try { window.localStorage.setItem(this.storageKey, String(this.end)); } catch (error) {}
        }
        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }
      disconnectedCallback() { window.clearInterval(this.timer); }
      update() {
        const now = Date.now();
        const cycleDuration = this.duration + this.expiredDuration;
        if (now >= this.end + this.expiredDuration) {
          const completedCycles = Math.floor((now - this.end - this.expiredDuration) / cycleDuration) + 1;
          this.end += completedCycles * cycleDuration;
          try { window.localStorage.setItem(this.storageKey, String(this.end)); } catch (error) {}
        }
        const remaining = Math.max(0, this.end - now);
        const total = Math.ceil(remaining / 1000);
        this.cells.hours.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
        this.cells.minutes.textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
        this.cells.seconds.textContent = String(total % 60).padStart(2, '0');
        if (remaining === 0) {
          this.dataset.expired = 'true';
        } else {
          delete this.dataset.expired;
        }
      }
    });
  }

  if (!customElements.get('ap-slider')) {
    customElements.define('ap-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.track?.children || []);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.previousButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.loop = this.hasAttribute('data-loop');
        this.pageCount = Number.parseInt(this.dataset.pageCount || '', 10);
        if (!this.track || !this.items.length) return;
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
        this.track.addEventListener('scroll', () => this.schedule(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1); }
          if (event.key === 'Home') { event.preventDefault(); this.go(0); }
          if (event.key === 'End') { event.preventDefault(); this.go(this.targets.length - 1); }
        });
        this.addEventListener('play', (event) => this.pauseOtherVideos(event.target), true);
        this.querySelectorAll('[data-video-toggle]').forEach((button) => {
          const card = button.closest('.ap-ugc-card, .ap-gallery__slide');
          const video = card?.querySelector('video');
          if (!video) return;
          const playIcon = button.querySelector('[data-play-icon]');
          const pauseIcon = button.querySelector('[data-pause-icon]');
          const videoLabel = video.getAttribute('aria-label') || 'video';
          video.controls = false;
          const syncVideoButton = () => {
            const playing = !video.paused && !video.ended;
            card.classList.toggle('is-playing', playing);
            playIcon?.toggleAttribute('hidden', playing);
            pauseIcon?.toggleAttribute('hidden', !playing);
            button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${videoLabel}`);
          };
          button.addEventListener('click', () => video.paused ? video.play() : video.pause());
          video.addEventListener('play', syncVideoButton);
          video.addEventListener('pause', syncVideoButton);
          video.addEventListener('ended', syncVideoButton);
          syncVideoButton();
        });
        this.onBlockSelect = (event) => {
          const item = event.target?.closest?.('.ap-slider__item, .ap-gallery__slide');
          if (item && this.contains(item)) this.showItem(item);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: .2 });
          this.querySelectorAll('video').forEach((video) => this.videoObserver.observe(video));
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.rebuild());
          this.resizeObserver.observe(this.track);
        }
        this.rebuild();
      }
      disconnectedCallback() {
        window.cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.videoObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      schedule() { window.cancelAnimationFrame(this.frame); this.frame = window.requestAnimationFrame(() => this.update()); }
      rebuild() {
        const origin = this.items[0]?.offsetLeft || 0;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.itemTargets = this.items.map((item) => Math.max(0, Math.min(maximum, item.offsetLeft - origin)));
        this.targets = this.itemTargets.filter((target, index, values) => index === 0 || Math.abs(target - values[index - 1]) > 2);
        if (Number.isFinite(this.pageCount) && this.pageCount > 0) this.targets = this.targets.slice(0, this.pageCount);
        if (!this.targets.length) this.targets = [0];
        this.dots.forEach((dot, index) => { dot.hidden = index >= this.targets.length; });
        this.update();
      }
      currentPage() {
        const left = Math.max(0, this.track.scrollLeft);
        let match = 0;
        let distance = Infinity;
        this.targets.forEach((target, index) => { const next = Math.abs(target - left); if (next < distance) { distance = next; match = index; } });
        return match;
      }
      update() {
        const current = this.currentPage();
        this.dots.forEach((dot, index) => {
          const active = !dot.hidden && index === current;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
        if (this.previousButton) this.previousButton.disabled = !this.loop && current === 0;
        if (this.nextButton) this.nextButton.disabled = !this.loop && current === this.targets.length - 1;
        const activeDot = this.dots[current];
        const dotTrack = activeDot?.parentElement;
        if (activeDot && dotTrack?.classList.contains('ap-gallery__thumbs')) dotTrack.scrollTo({ left: activeDot.offsetLeft - (dotTrack.clientWidth - activeDot.offsetWidth) / 2, behavior: 'smooth' });
      }
      pauseOtherVideos(activeVideo) { this.querySelectorAll('video').forEach((video) => { if (video !== activeVideo && !video.paused) video.pause(); }); }
      showItem(item) {
        const index = this.items.indexOf(item);
        if (index < 0) return;
        const target = this.itemTargets[index];
        const page = this.targets.reduce((best, value, nextIndex) => Math.abs(value - target) < Math.abs(this.targets[best] - target) ? nextIndex : best, 0);
        this.go(page);
      }
      move(direction) {
        const proposed = this.currentPage() + direction;
        if (this.loop) this.go((proposed + this.targets.length) % this.targets.length);
        else this.go(Math.max(0, Math.min(this.targets.length - 1, proposed)));
      }
      go(index) {
        const safeIndex = this.loop ? (index + this.targets.length) % this.targets.length : Math.max(0, Math.min(this.targets.length - 1, index));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.targets[safeIndex] || 0, behavior: reduced ? 'auto' : 'smooth' });
      }
    });
  }

  if (!customElements.get('ap-product-controls')) {
    customElements.define('ap-product-controls', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-variant-select]');
        this.price = this.querySelector('[data-product-price]');
        this.button = this.querySelector('[data-atc]');
        this.buttonText = this.button?.querySelector('.button-text');
        this.quantity = this.querySelector('[data-bundle-quantity]');
        this.bundleChoices = Array.from(this.querySelectorAll('[data-bundle-choice]'));
        this.onSubmit = (event) => this.goToCheckout(event);
        this.onPageShow = () => this.resetCheckoutState();
        this.form?.addEventListener('submit', this.onSubmit, true);
        window.addEventListener('pageshow', this.onPageShow);
        this.select?.addEventListener('change', () => this.updateVariant());
        this.bundleChoices.forEach((choice) => choice.addEventListener('change', () => this.updateBundle()));
        this.updateVariant();
        this.updateBundle();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit, true);
        window.removeEventListener('pageshow', this.onPageShow);
      }
      updateVariant() {
        const option = this.select?.tagName === 'SELECT' ? this.select.selectedOptions[0] : this.select;
        if (!option || !this.button) return;
        const available = option.dataset.available === 'true';
        this.button.disabled = !available;
        if (available) this.button.removeAttribute('aria-disabled'); else this.button.setAttribute('aria-disabled', 'true');
        if (this.buttonText) this.buttonText.textContent = available ? this.button.dataset.availableText : this.button.dataset.soldText;
      }
      updateBundle() {
        const selected = this.bundleChoices.find((choice) => choice.checked) || this.bundleChoices[0];
        if (!selected) return;
        if (this.select && selected.dataset.variantId) {
          this.select.value = selected.dataset.variantId;
          this.select.dataset.available = selected.dataset.available;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.quantity) this.quantity.value = selected.dataset.quantity || '1';
        if (this.price) this.price.textContent = selected.dataset.total || '';
        this.dispatchEvent(new CustomEvent('ap:bundle-change', { bubbles: true }));
      }
      resetCheckoutState() {
        this.checkoutPending = false;
        this.button?.classList.remove('loading');
        this.button?.querySelector('.loading__spinner')?.classList.add('hidden');
        this.updateVariant();
      }
      async goToCheckout(event) {
        if (event.submitter && event.submitter !== this.button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.form || !this.button || this.button.disabled || this.checkoutPending) return;
        this.checkoutPending = true;
        const spinner = this.button.querySelector('.loading__spinner');
        const errorWrapper = this.form.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
        this.button.classList.add('loading');
        this.button.setAttribute('aria-disabled', 'true');
        spinner?.classList.remove('hidden');
        errorWrapper?.setAttribute('hidden', '');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const formData = new FormData(this.form);
          const variantId = String(formData.get('id') || '');
          if (!variantId) throw new Error('Please select an available option.');

          const cartResponse = await window.fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            cache: 'no-store'
          });
          const cart = await cartResponse.json();
          if (!cartResponse.ok) throw new Error(cart.description || cart.message || cartResponse.statusText);

          const offerVariantIds = new Set(this.bundleChoices.map((choice) => String(choice.dataset.variantId)));
          const updates = {};
          (cart.items || []).forEach((item) => {
            if (offerVariantIds.has(String(item.variant_id))) updates[item.key] = 0;
          });

          if (Object.keys(updates).length) {
            const updateResponse = await window.fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ updates })
            });
            const updatedCart = await updateResponse.json();
            if (!updateResponse.ok || updatedCart.status) {
              throw new Error(updatedCart.description || updatedCart.message || updateResponse.statusText);
            }
          }

          const addUrl = window.routes?.cart_add_url || `${root}cart/add.js`;
          const response = await window.fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || response.statusText);
          window.location.assign(`${root}checkout`);
        } catch (error) {
          if (errorMessage) errorMessage.textContent = error.message;
          errorWrapper?.removeAttribute('hidden');
          this.resetCheckoutState();
        }
      }
    });
  }

  if (!customElements.get('ap-timeline')) {
    customElements.define('ap-timeline', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-timeline-list]');
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        if (!this.list || !this.items.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.list.style.setProperty('--ap-progress', '100%');
          this.items.forEach((item) => item.classList.add('is-active'));
          return;
        }
        this.onViewportChange = () => this.schedule();
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange);
        this.schedule();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
        window.cancelAnimationFrame(this.frame);
      }
      schedule() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }
      update() {
        const listRect = this.list.getBoundingClientRect();
        const trigger = window.innerHeight * .62;
        const progress = Math.max(0, Math.min(1, (trigger - listRect.top) / Math.max(1, listRect.height)));
        this.list.style.setProperty('--ap-progress', `${progress * 100}%`);
        this.items.forEach((item) => item.classList.toggle('is-active', item.getBoundingClientRect().top <= trigger));
      }
    });
  }

  if (!customElements.get('ap-mobile-buybar')) {
    customElements.define('ap-mobile-buybar', class extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('#ap-buybox [data-atc]');
        this.mainPrice = document.querySelector('#ap-buybox [data-product-price]');
        this.mobileButton = this.querySelector('[data-mobile-atc]');
        this.mobilePrice = this.querySelector('[data-mobile-price]');
        if (!this.mainButton || !this.mobileButton) return;
        this.sync = () => {
          this.mobileButton.disabled = this.mainButton.disabled;
          this.mobileButton.textContent = this.mainButton.querySelector('.button-text')?.textContent || this.mobileButton.textContent;
          if (this.mobilePrice && this.mainPrice) this.mobilePrice.textContent = this.mainPrice.textContent;
        };
        this.mobileButton.addEventListener('click', () => { if (!this.mainButton.disabled) this.mainButton.click(); });
        this.mutationObserver = new MutationObserver(this.sync);
        this.mutationObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        if (this.mainPrice) this.mutationObserver.observe(this.mainPrice, { childList: true, subtree: true });
        this.visibilityObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
          const visible = !entry.isIntersecting;
          this.classList.toggle('is-visible', visible);
          this.toggleAttribute('inert', !visible);
          this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        }), { threshold: 0 });
        this.visibilityObserver.observe(this.mainButton);
        this.sync();
      }
      disconnectedCallback() { this.mutationObserver?.disconnect(); this.visibilityObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
